"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Pill: true
};
Object.defineProperty(exports, "Pill", {
  enumerable: true,
  get: function get() {
    return _Pill.default;
  }
});

var _constants = require("./constants");

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

var _Pill = _interopRequireDefault(require("./Pill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }